import type { ReportColumn, ReportRow } from "./types";

/** Rapport-rader → CSV (semikolon-separert, råverdier). Delt av eksport + test. */
export function rowsToCsv(columns: ReportColumn[], rows: ReportRow[]): string {
  const header = columns.map((c) => c.label).join(";");
  const lines = rows.map((r) =>
    columns.map((c) => (c.key === "label" ? r.label : String(r.cells[c.key] ?? ""))).join(";"),
  );
  return [header, ...lines].join("\n");
}
